// @ts-ignore
import type {OutputSelector} from 'reselect';
import type {Territory} from '../types';
import {Collections} from '../collections';
import type {CollectionState} from '../collections';

type TerritoriesModuleState = {
    territories: CollectionState<Territory>;
};
/*
 * Given the entire redux state, pull out just the piece of state for the territories reducer.
 */
const getTerritoriesState = (state: TerritoriesModuleState) => state.territories;

/*
 * Get an array of all territories models
 */
export const getAll: OutputSelector<any, any, Territory[]> =
    Collections.makeGetModels(getTerritoriesState);

/*
 * Get the `byId` portion of the territories state
 */
export const getById = (state: TerritoriesModuleState) => {
    const territoriesState = getTerritoriesState(state);

    return Collections.getById(territoriesState);
};
